export const actionTypes = {
    GET_ASSET_SCATTER_KPIS_V2: 'operationalParameters_v2/GET_ASSET_SCATTER_KPIS_V2',
    GET_SCATTER_V2: 'operationalParameters_v2/GET_SCATTER_V2',
    SET_SCATTER_KPI_V2: 'operationalParameters_v2/SET_SCATTER_KPI_V2',
    REMOVE_TREND_KPI_SELECTION_LEGEND_SCATTER_V2: 'operationalParameters_v2/REMOVE_TREND_KPI_SELECTION_LEGEND_SCATTER_V2'
};

export const RESPONSE_DATE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';
